var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@tanstack/react-query';
import { eligibilityCacheKey } from './eligibility-cache-key';
import ENDPOINTS from '../../const/endpoints';
import { fetchConfig } from '../../helpers';
function useEligibilityQuery(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.queryOptions, queryOptions = _b === void 0 ? {} : _b;
    var fetchWrapper = fetchConfig(config);
    return useQuery(__assign({ queryKey: eligibilityCacheKey(keyProps), queryFn: function () {
            var params = new URLSearchParams({
                'cipher.accountId': keyProps.accountId,
                accountIdType: keyProps.accountIdType
            });
            return fetchWrapper("".concat(ENDPOINTS.refundEligibility, "?").concat(params), {
                method: 'GET'
            });
        } }, queryOptions));
}
export default useEligibilityQuery;
